/**
 *  @class
 *  @function CustomCookiesIcon
 */
if (!customElements.get('custom-cookies-icon')) {
  class CustomCookiesIcon extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
    }

    connectedCallback() {
      window.addEventListener('scroll', this.checkVisible.bind(this));
    }

    checkVisible(event) {
      window.requestAnimationFrame(() => {
        let y = window.scrollY;
        if (y > this.pageHeight) {
          this.classList.add('custom-cookies-icon--active');
        } else {
          this.classList.remove('custom-cookies-icon--active');
        }
      });
    }
  }
  customElements.define('custom-cookies-icon', CustomCookiesIcon);
}
